import React from 'react';

// Components
import DatesDisclaimer from './DatesDisclaimer';

// Types
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';
import User from '@/types/user';

// Utils
import { DISCLAIMER_KEYS } from '@/utils/disclaimers/constants';
import { formatMessageWithLocale } from '@/utils/i18n';
import { getAllocationsAsAtDates, getInvestmentInfoDates } from '@/utils/disclaimers/comparison';
import { getPreferredDataProvider, isPreferredProviderRefinitiv } from '@/utils/users';

interface Props {
  items: ComparisonItem[];
  showItemNames?: boolean;
  locale?: Locale;
  user?: User;
}

const EquityStyleDisclaimer = ({ items, locale, showItemNames, user }: Props) => {
  const equityItems = items.filter(
    i =>
      !!i.disclaimers &&
      (!i.disclaimers[DISCLAIMER_KEYS.FUND_EQUITY_METRICS_NOT_APPLICABLE] || !i.disclaimers[DISCLAIMER_KEYS.PORTFOLIO_EQUITY_METRICS_NOT_APPLICABLE]),
  );

  const preferredProvider = user && getPreferredDataProvider(user, 'fundPortfolio.investmentInfo.capitalization');

  return (
    <>
      <DatesDisclaimer
        globalPrefix={formatMessageWithLocale('Disclaimers.EquityStyle', locale)}
        itemPrefix={formatMessageWithLocale('Disclaimers.AsAt', locale)}
        itemDates={getInvestmentInfoDates(equityItems, locale)}
        showItemNames={showItemNames}
        locale={locale}
      />
      {isPreferredProviderRefinitiv(preferredProvider) && (
        <DatesDisclaimer
          globalPrefix={formatMessageWithLocale('Disclaimers.EquityStyleMarketCap', locale)}
          itemPrefix={formatMessageWithLocale('Disclaimers.AsAt', locale)}
          itemDates={getAllocationsAsAtDates(equityItems, locale)}
          showItemNames={showItemNames}
          locale={locale}
        />
      )}
    </>
  );
};

export default EquityStyleDisclaimer;
